import EIQuiz from '../components/EIQuiz';
import '../styles/EIQuiz.css';

function QuizPage() {
  return (
    <div className="quiz-page">
      <EIQuiz />
    </div>
  );
}

export default QuizPage;
